module.exports = __webpack_public_path__ + "img/2012pigc.3bc9ca0f.png";